import {DefaultBindingProduct} from "../Extras/Services/USSDServices/USSDServicesCommon";
import _ from "lodash";
import TTLProxy from "../../common/TTLAsyncProxy";
import {TractorRequestEndpoints, TractorsEndpoints} from "../../common/ProxyEndpoints";

export const serviceHasProductSelection = (service,group) => {

    let pricing = service.pricing;

    if(!_.isNil(group))
        pricing = pricing.filter(x => x.pricing_group.id === group.id);

    return (pricing.length > 1 && !!pricing.find(x => x.product !== DefaultBindingProduct)) || (pricing.length === 1 && pricing[0].product !== DefaultBindingProduct)
};

export const getServiceRegions = (service) => {
    const pricing = service.pricing.map(x => x.pricing_group);
    return _.uniqBy(pricing,'id').filter(x => x.active);
};

export const getServiceProductsList = (service,pricingGroup) => {

    if(pricingGroup){
        return service.pricing.filter(p => p.pricing_group.id === pricingGroup.id);
    }

    return _.uniqBy(service.pricing,'product');
};

export const checkTractorAvailability = async (service,province,district,ward) => {

    const proxy = TTLProxy.getInstance();
    const res = await proxy.processRequest(TractorsEndpoints.checkAvailability(service,province,district,ward));
    return res.getPayload();

};

export const calculateRequestCost  = async (amount , service, pricingGroup, pricingInfo ) => {

    const proxy = TTLProxy.getInstance();
    const res = await proxy.processRequest(TractorRequestEndpoints.calculateRequestCost(service.id,
        amount ,
        pricingGroup ? pricingGroup.id : null,
        pricingInfo ? pricingInfo.id : null
    ));

    return res.getPayload();
};


// WEBPACK FOOTER //
// ./src/views/Request/RequestUtils.js